import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface CardChartProps {
  title: string;
  value: string | number;
}

export function CardChart({ title, value }: CardChartProps) {
  return (
    <Card className="text-center">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-4xl font-bold text-gray-800">
          {typeof value === "number"
            ? value.toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
              })
            : value}
        </div>
      </CardContent>
    </Card>
  );
}
